import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VisitorCounter = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const alreadyCounted = sessionStorage.getItem('ambarsariya_visited');
    const run = async () => {
      try {
        const res = await fetch(`${API}/visitors`, {
          method: alreadyCounted ? 'GET' : 'POST',
        });
        const data = await res.json();
        setCount(data.count);
        if (!alreadyCounted) sessionStorage.setItem('ambarsariya_visited', '1');
      } catch (e) {
        // silently ignore
      }
    };
    run();
  }, []);

  if (count === null) return null;

  return (
    <div
      data-testid="visitor-counter"
      className="flex items-center justify-center gap-2 text-gray-400 text-sm mt-4"
    >
      <Users className="w-4 h-4 text-yellow-400" />
      <span>
        <span className="font-bold text-yellow-400" data-testid="visitor-count">
          {count.toLocaleString()}
        </span>{' '}
        visitors have explored Ambarsariya
      </span>
    </div>
  );
};

export default VisitorCounter;
